import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styles from "./devoteeManagement.module.scss";
import constants from "../../config/constants.json";
import {
  CommonButton,
  CustomCheckbox,
  CustomInputLabel,
  CustomMenuItem,
  CustomSelectforPooja,
  CustomTextFeildPooja,
} from "../common/StyledComponents/StyledFields";
import apiPath from "../../config/apiPaths.json";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../infrastructure/backendService";
import Pagination from "../common/pagination/pagination";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ClipLoader } from "react-spinners";
import toast, { Toaster } from "react-hot-toast";
import LOCALE from "../../config/en-us.json";
import { isEqual, isNil } from "lodash";
import SuccessPopup from "../devotee/donation/successPopup";
import ErrorPopup from "../common/ErrorPopup";
interface DataRowProps {
  firstname: string;
  middleName: string;
  lastname: string;
  username: string;
  email: string;
  dateOfBirth: null | string;
  phoneWork: string;
  phoneResidence: string;
  gothram: string;
  nakshatram: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  country: string;
  preferredLanguage: string;
  category: number;
}

interface filterFormProps {
  username?:string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  zipCode: string;
}

const DuplicateDevotee = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<DataRowProps[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);
  const [selectedMode, setSelectedMode] = useState<string |  null>(null);
  const itemsPerPageList = [25, 30, 35, 40, 45, 50];
  const [searchedData, setSearchedData] = useState<DataRowProps[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [showTableData, setShowTableData] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [filterForm, setFilterForm] = useState<filterFormProps>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    zipCode: "",
  });
  const [refFilterFormData, setRefFilterFormData] = useState<filterFormProps>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    zipCode: "",
  });
  const [isAPICalled, setIsAPICalled] = useState(false)
 

  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }

  // Use the custom hook to track previous values
  const prevPageNumber = usePrevious(pageNumber);
  const prevPageSize = usePrevious(pageSize);

  useEffect(() => {

    if(!isNil(selectedMode) && !isAPICalled && !isEqual(filterForm, refFilterFormData)){
      setIsAPICalled(true);
      setRefFilterFormData({...filterForm})
      getAllData();
    }
  }, [selectedMode, pageNumber, pageSize, filterForm.firstName, filterForm.lastName, filterForm.email, filterForm.phoneNumber, filterForm.zipCode, isAPICalled]); // Dependencies array, re-run the effect when these values change

  const getAllData = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.duplicateDevotee,
      includeToken: true,
      params: {
        mode: selectedMode,
        page: pageNumber - 1,
        size: pageSize,
        firstname: filterForm.firstName || null, 
        lastname: filterForm.lastName || null,
        email: filterForm.email || null,
        phoneNumber: filterForm.phoneNumber || null,
        zipCode: filterForm.zipCode || null
      },
    })
      .then((res) => {
        setSearchedData(res.data.content);
        setTotalRecords(res.data.totalElements);
        setIsAPICalled(false);
        //   setSearchLoading(false);
        //   setShowTableData(true);
        //   toast.custom(<ToastSuccess message="Data retrived Successfully."/>);
      })
      .catch((err) => {
        //   setSearchLoading(false);
        setIsAPICalled(false);
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const radioButtons = (): React.ReactElement => {
    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchButton(false);
      setFilterForm({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        zipCode: "",
      });
      setSelectedMode(event.target.value);
    };

    return (
      <RadioGroup sx={{ marginBottom: "16px" }} onChange={handleRadioChange}>
        <FormControlLabel
          value="FIRSTNAME_LASTNAME"
          id="firstAndLastName"
          control={
            <Radio
              sx={{
                "& .MuiSvgIcon-root": { fontSize: 24, fill: "#f05802" },
                color: "#F05802",
              }}
            />
          }
          label="First Name + Last Name"
        />
        <FormControlLabel
          value="FIRSTNAME_LASTNAME_PHONE"
          id="firstAndLastAndPhone"
          control={
            <Radio
              sx={{
                "& .MuiSvgIcon-root": { fontSize: 24, fill: "#f05802" },
                color: "#F05802",
              }}
            />
          }
          label="First Name + Last Name + Phone Number"
        />
        <FormControlLabel
          value="FIRSTNAME_LASTNAME_EMAIL"
          id="firstAndLastAndEmail"
          control={
            <Radio
              sx={{
                "& .MuiSvgIcon-root": { fontSize: 24, fill: "#f05802" },
                color: "#F05802",
                fill: "#f05802",
              }}
            />
          }
          label="First Name + Last Name + Email"
        />
        <FormControlLabel
          value="FIRSTNAME_LASTNAME_ADDRESS"
          id="firstAndLastAndAddress"
          control={
            <Radio
              sx={{
                "& .MuiSvgIcon-root": { fontSize: 24, fill: "#f05802" },
                color: "#F05802",
                fill: "#f05802",
              }}
            />
          }
          label="First Name + Last Name + Address"
        />
      </RadioGroup>
    );
  };

  const handleSelectAll = () => {
    const allSelected = searchedData.every((row) =>
      selectedRows.some(
        (selectedRow: DataRowProps) => selectedRow.username === row.username
      )
    );

    if (!allSelected) {
      setSelectedRows([...searchedData]);
      setSelectedUsers(searchedData.map((row) => row.username));
    } else {
      setSelectedRows([]);
      setSelectedUsers([]);
    }
  };

  const handleCheckboxChange = (username: string) => {
    const selectedRow = searchedData.find(
      (row: DataRowProps) => row.username === username
    );

    if (selectedRow) {
      if (selectedRows.some((row: DataRowProps) => row.username === username)) {
        setSelectedRows((prev) =>
          prev.filter((row: DataRowProps) => row.username !== username)
        );
      } else {
        setSelectedRows((prev) => [...prev, selectedRow]);
      }

      // Update selectedUsers state
      if (selectedUsers.includes(username)) {
        setSelectedUsers((prevUsers) =>
          prevUsers.filter((user) => user !== username)
        );
      } else {
        setSelectedUsers((prevUsers) => [...prevUsers, username]);
      }
    }

    // Uncheck "Select All" when any other checkbox is clicked
    if (selectedRows.length === searchedData.length && !selectedRow) {
      setSelectedRows([]);
    }
  };

  const searchSumbitApiCall = () => {
    setSearchLoading(true);
    setFilterForm({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      zipCode: "",
    })
    apiRequest({
      method: "GET",
      endpoint: apiPath.duplicateDevotee,
      includeToken: true,
      params: {
        mode: selectedMode,
        page: pageNumber - 1,
        size: pageSize,
      },
    })
      .then((res) => {
        setSearchedData(res.data.content);
        setTotalRecords(res.data.totalElements);
        setSearchLoading(false);
        setShowTableData(true);
        // toast.custom(<ToastSuccess message={LOCALE.DUPLICATE_DEVOTEE_DATA_RETRIVED_SUCCESS} />);
        toast.custom(<SuccessPopup headerMessage="Duplicate Data" showMessage={LOCALE.DUPLICATE_DEVOTEE_DATA_RETRIVED_SUCCESS} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
      })
      .catch((err) => {
        setSearchLoading(false);
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };
  const handleFieldChange = (field: any, value: any) => {
    setFilterForm({
      ...filterForm,
      [field]: value,
    });
  }

  const namesFieldFilter = (): React.ReactElement => {
    return (
      <div style={{ display: "flex", justifyContent: "end" , gap: "10px"}}>
        <div>
          {/* <CustomInputLabel>Firstname</CustomInputLabel> */}
          <CustomTextFeildPooja
            value={filterForm.firstName}
            className={styles.textFieldBorder}
            onChange = {(e) => { setPageNumber(1); handleFieldChange("firstName",e.target.value)}}
            placeholder="Firstname"
          />
        </div>
        <div>
          {/* <CustomInputLabel>Lastname</CustomInputLabel> */}
          <CustomTextFeildPooja
            value={filterForm.lastName}
            className={styles.textFieldBorder}
            onChange={(e) => {
              setPageNumber(1);
              handleFieldChange("lastName", e.target.value || null);
            }}
            placeholder="Lastname"
          />
        </div>
      </div>
    );
  };

  const duplicatefiltersComponent = (): React.ReactElement => {
    return (
      <div style={{ display: "flex", gap: "10px", marginTop:"22px" }}>
        <div style={{ width: "30%" }}>{namesFieldFilter()}</div>
        <div style={{ width: "20%" }}>
          {emailFieldFilter()}
        </div>
        <div style={{ width: "20%" }}>
          {phoneNumberFieldFilter()}
        </div>
        <div style={{ width: "15%" }}>
        {zipCodeFieldFilter()}
        </div>
      </div>
    );
  };

  const emailFieldFilter = (): React.ReactElement => {
    return (
      <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
        <div>
          {/* <CustomInputLabel>Email</CustomInputLabel> */}
          <CustomTextFeildPooja
            value={filterForm.email}
            className={styles.textFieldBorder}
            onChange={(e) => {
              setPageNumber(1);
              handleFieldChange("email", e.target.value);;
            }}
            placeholder="Email"
          />
        </div>
      </div>
    );
  };

  const phoneNumberFieldFilter = (): React.ReactElement => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <div>
          {/* <CustomInputLabel>Phone Number</CustomInputLabel> */}
          <CustomTextFeildPooja
            value={filterForm.phoneNumber}
            className={styles.textFieldBorder}
            onChange={(e) => {
              setPageNumber(1);
              handleFieldChange("phoneNumber", e.target.value || null);
            }}
            placeholder="Phone Number"
          />
        </div>
      </div>
    );
  };

  const zipCodeFieldFilter = (): React.ReactElement => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <div>
          {/* <CustomInputLabel>Zip Code</CustomInputLabel> */}
          <CustomTextFeildPooja
            value={filterForm.zipCode}
            className={styles.textFieldBorder}
            onChange={(e) => {
              setPageNumber(1);
              handleFieldChange("zipCode", e.target.value || null);
            }}
            placeholder="Zip Code"
          />
        </div>
      </div>
    );
  };
  const renderTableComponent = () => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "end" , gap:"10px"}}>
        {duplicatefiltersComponent()}
        <Grid item xs={12} sm={4} sx={{marginLeft:"-75px"}}>
                <CustomInputLabel>Items Per Page</CustomInputLabel>
                {itemPerPageDropdown()}
              </Grid>
          <CommonButton
            disabled={selectedUsers.length === 0 || loading}
            onClick={addToConsolidateApi}
            style={{ width: "25%", marginTop:"22px" }}
          >
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Please wait...
                </span>
              </>
            ) : (
              "Add to Consolidate"
            )}
          </CommonButton>
        </div>
        <div style={{overflowY: "auto"}}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>
                  <div>
                    <CustomCheckbox
                      checked={selectedRows.length === searchedData.length}
                      onChange={handleSelectAll}
                    />
                  </div>
                </th>
                <th className={styles.tableHorizontal}>Sign-In Name</th>
                <th className={styles.tableHorizontal}>First Name</th>
                <th className={styles.tableHorizontal}>Last Name</th>
                <th className={styles.tableHorizontal}>Address</th>
                <th className={styles.tableHorizontal}>City</th>
                <th className={styles.tableHorizontal}>State</th>
                <th className={styles.tableHorizontal}>Zipcode</th>
                <th className={styles.tableHorizontal}>Home Phone</th>
                <th className={styles.tableHorizontal}>Email</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {searchedData.map((row: DataRowProps, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>
                    <CustomCheckbox
                      checked={selectedRows.some(
                        (selectedRow) => selectedRow.username === row.username
                      )}
                      onChange={() => handleCheckboxChange(row.username)}
                    />
                  </td>
                  <td className={styles.tableDiagonal}>{row.username}</td>
                  <td className={styles.tableDiagonal}>{row.firstname}</td>
                  <td className={styles.tableDiagonal}>{row.lastname}</td>
                  <td className={styles.tableDiagonal}>{row.address}</td>
                  <td className={styles.tableDiagonal}>{row.city}</td>
                  <td className={styles.tableDiagonal}>{row.state}</td>
                  <td className={styles.tableDiagonal}>{row.zipcode}</td>
                  <td className={styles.tableDiagonal}>{row.phoneResidence}</td>
                  <td className={styles.tableDiagonal}>{row.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalRecords > pageSize ? (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "10px",
                marginTop: "20px",
                gap: "10px",
                marginLeft: "auto",
              }}
            >
     
              <Pagination
                items={totalRecords}
                itemsPerPage={pageSize}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  };

  const itemPerPageDropdown = (): React.ReactElement => {
    const handleChangePageSize = (e: any) => {
      setPageSize(e.target.value);
      searchSumbitApiCall();
    };

    return (
      <FormControl
        className={styles.textFieldBorder}
      >
        <CustomSelectforPooja
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          onChange={handleChangePageSize}
          value={pageSize}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {itemsPerPageList.map((item: number, i: number) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelectforPooja>
      </FormControl>
    );
  };

  const addToConsolidateApi = () => {
    const reqBody = {
      accountsToConsolidate: selectedUsers,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.accountsToConsolidate,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setLoading(false);
        setShowTableData(true);
        setSelectedRows([]);
        setSelectedUsers([]);
        getAllData();
        const successMessage = LOCALE.ACCOUNTS_ADDED_TO_CONSOLIDATE;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //    duration: 10000,
        // });
        toast.custom(<SuccessPopup headerMessage="Accounts" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
        {
          duration: constants.TOAST_POPUP_DURATION,
        });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const showTableComponent = () => {
   return (
      <>
      {totalRecords > 0 ? renderTableComponent() : <Typography sx={{textAlign:"center"}}>No Records found.</Typography>}
      </>
   )
  }
  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent the default form submission behavior
      searchSumbitApiCall();
    }
  };

  return (
    <form className={styles.DuplicateDevoteeLayout} onKeyDown={handleKeyPress}>
      <Toaster />
      <Typography className={styles.SubHeading}>Duplicate Devotee</Typography>
      <Box className={styles.formLayout}>{radioButtons()}</Box>
      <Box sx={{ marginTop: "24px" }}>
        <CommonButton
          onClick={searchSumbitApiCall}
          disabled={searchLoading || loading || searchButton}

        >
          {searchLoading ? (
            <>
              <ClipLoader color="#fff" loading={searchLoading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Loading...
              </span>
            </>
          ) : (
            "Search"
          )}
        </CommonButton>
      </Box>
      {showTableData ?  showTableComponent() : ""}
    </form>
  );
};

export default DuplicateDevotee;
